import type { JSX } from 'react'

interface Props {
  className: string
}

const Logo = ({ className }: Props): JSX.Element => {
  return (
    <>
      <span className="sr-only">Alex Caballero</span>
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 455.279 455.279"
      >
        <g
          id="alex_caballero_logo"
          data-name="Alex Caballero Logo"
          transform="translate(-5636.379 -220.501)"
        >
          <path
            id="path"
            data-name="Path"
            d="M5858.989,552.64a37.8,37.8,0,0,0,53.45,0h0a37.816,37.816,0,0,0,10.081-17.389l35.88-133.9c7.6-28.365-18.355-54.32-46.719-46.72l-133.906,35.88a37.823,37.823,0,0,0-17.387,10.083h0a37.815,37.815,0,0,0,36.478,63.268,42.256,42.256,0,0,1,52.419,52.056A37.736,37.736,0,0,0,5858.989,552.64Z"
            fill="#fff"
          />
        </g>
      </svg>
    </>
  )
}

export default Logo
